import { createSelector } from '@reduxjs/toolkit';
import { AppState } from '../types';
import { UserState } from './slice';

export const userStateSelector = (state: AppState): UserState => state.user;

export const userSelector = createSelector(userStateSelector, (s: UserState) => s.user);

export const loggedInSelector = createSelector(userStateSelector, (s: UserState) => s.loggedIn);
